import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatMailboxTypesPipeModule } from 'src/app/pipes/format-mailbox-types-pipe/format-mailbox-types-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { MailboxMessagesRegisterModule } from '../mailbox-messages/mailbox-messages-register.module';
import { MailboxDetailStandaloneComponent } from './containers/mailbox-standalone-detail.component';
import { MailboxDetailEffects } from './state/mailbox-detail.effects';
import * as fromMailboxDetail from './state/mailbox-detail.reducer';
import { MailboxDetailLeftColumnComponent } from './views/mailbox-detail-sections/mailbox-detail-left-column.component';
import { MailboxDetailComponent } from './views/mailbox-detail-sections/mailbox-detail-view.component';
import { MailboxDetailViewComponent } from './views/mailbox-standalone-detail-view.component';

@NgModule({
   declarations: [
      MailboxDetailViewComponent,
      MailboxDetailStandaloneComponent,
      MailboxDetailComponent,
      MailboxDetailLeftColumnComponent,
   ],
   exports: [MailboxDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      RouterModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      MatSlideToggleModule,
      EntitySelectModule,
      ErrorPageModule,
      CardLayoutModule,
      FormatMailboxTypesPipeModule,
      StoreModule.forFeature(fromMailboxDetail.mailboxDetailFeatureKey, fromMailboxDetail.reducer),
      EffectsModule.forFeature([MailboxDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      MailboxMessagesRegisterModule,
   ],
})
export class MailboxDetailStandaloneModule {}
